const RESERVED_LABELS = new Set([
  "node",
  "segment",
  "circle",
  "angle",
  "triangle",
  "polygon",
  "point",
  "line",
  "shape",
  "relation",
  "dependency",
  "annotation"
]);

function isInternalGeometryId(value) {
  const text = String(value || "").trim();
  if (!text) return false;
  return /^(node|segment|circle|angle|triangle|polygon|point|line|shape|relation|dependency|annotation)(?:[_\d-].*)?$/i.test(
    text
  );
}

function normalizeLabel(value, fallback = "") {
  const text = String(value || fallback || "").trim();
  if (!text) return "";
  if (isInternalGeometryId(text)) return "";
  const match = text.match(/[A-Za-z][A-Za-z0-9]*/);
  const normalized = match ? match[0] : text;
  if (RESERVED_LABELS.has(normalized.toLowerCase())) return "";
  return normalized;
}

function normalizePos(pos) {
  if (Array.isArray(pos) && pos.length >= 2) {
    const x = Number(pos[0]);
    const y = Number(pos[1]);
    if (Number.isFinite(x) && Number.isFinite(y)) return [x, y];
  }

  if (pos && typeof pos === "object") {
    const x = Number(pos.x);
    const y = Number(pos.y);
    if (Number.isFinite(x) && Number.isFinite(y)) return [x, y];
  }

  return null;
}

export function extractFigureAssistLabelHints({ figureSpec, diagramSchema }) {
  const suggestedPoints = [];
  const seen = new Set();

  function addPoint(label, pos) {
    const normalized = normalizeLabel(label);
    if (!normalized) return;
    const key = normalized.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    const next = { label: normalized };
    const normalizedPos = normalizePos(pos);
    if (normalizedPos) next.pos = normalizedPos;
    suggestedPoints.push(next);
  }

  if (figureSpec?.entities?.points) {
    const points = Array.isArray(figureSpec.entities.points) ? figureSpec.entities.points : [];
    points.forEach((point) => addPoint(point?.label || point?.id, point?.pos));
  } else if (figureSpec?.points && typeof figureSpec.points === "object") {
    Object.entries(figureSpec.points).forEach(([id, point]) => {
      addPoint(point?.label || id, point?.pos || point);
    });
  }

  if (Array.isArray(diagramSchema?.entities?.points)) {
    diagramSchema.entities.points.forEach((point) => addPoint(point?.label || point?.id));
  }

  return {
    suggestedPoints,
    suggestedLabels: suggestedPoints.map((point) => point.label)
  };
}
